<template>
  <div class="insurance-contact">
    <div
      v-for="(item, index) in getAvailableContactInfo"
      :key="index"
      :class="getCSSClasses(item)"
    >
      <h3
        class="insurance-contact__header"
        v-html="$t(item.header)"
      />
      <div
        class="insurance-contact__description"
        v-html="$t(item.description)"
      />
      <div
        v-if="item.key === 'post'"
        class="insurance-contact__description insurance-contact__description--strong"
        v-html="getItemPostAddress(item)"
      />
      <div
        v-if="item.cta"
        class="insurance-contact__cta"
      >
        <BaseButton
          v-if="item.cta"
          :text="$t(item.cta)"
          @click="handleCTAButtonClick(item)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import BaseButton from '@shared/components/BaseButton.vue'
import { computed } from 'vue'

const props = defineProps({
  contactData: {
    type: Object,
    default: () => Object.create(null),
  },
})

const emit = defineEmits(['cta'])

const getAvailableContactInfo = computed(() => {
  const { allowedItems, actualItems } = getCorporateContactData.value

  return [].concat(allowedItems).filter((item) => {
    if (item.key === 'post' && actualItems.address == null) {
      return false
    }

    return actualItems[item.key] != null
  })
})

const getCorporateContactData = computed(
  () =>
    props.contactData || {
      actualItems: {},
      allowedItems: [],
    },
)

const getItemPostAddress = computed(
  () => getCorporateContactData.value.actualItems.address,
)

const getCSSClasses = (item) => [
  'insurance-contact__item',
  `insurance-contact__item--${item.key}`,
]

const handleCTAButtonClick = (item) => {
  emit('cta', {
    item,
    actualItems: getCorporateContactData.value.actualItems,
  })
}
</script>

<style lang="scss">
.insurance-contact {
  &__header {
    @include kds-typography-title-xlarge;
    margin: 0;
    margin-top: 32px;
  }

  &__description {
    @include kds-typography-paragraph-large;
    margin: 16px 0;
    color: $kds-color-text-secondary;
    overflow: hidden;
    text-overflow: ellipsis;

    &--strong {
      @include kds-typography-title-medium;
    }
  }

  &__cta {
    .interactive-button {
      padding: 8px;
      color: $kds-color-text-primary-inverse;

      @include kds-typography-title-medium;
    }
  }

  @include media-up(md) {
    &__cta {
      width: 50%;
    }
  }
}
</style>
